import "../css/index.css";

// Import JS
import darkModeToggle from "./dark-mode-toggle";

// DOM tamamen yüklendiğinde darkModeToggle fonksiyonunu çağır
document.addEventListener("DOMContentLoaded", () => {
    darkModeToggle();
});
